import { useCallback } from "react";
import { useAsync } from "@/shared/hooks/HookBase";
import IntegrationAccessService from "../services/IntegrationAccessService";
import type IntegrationAccess from "../models/IntegrationAccess";
import type { GrantAccessRequest } from "../services/IntegrationAccessService";

const integrationAccessService = new IntegrationAccessService();

export function useIntegrationAccess() {
  const { loading, error, execute } = useAsync();

  const getAll = useCallback(async (): Promise<
    IntegrationAccess[] | void
  > => {
    return await execute(() => integrationAccessService.getAll());
  }, [execute]);

  const getByUser = useCallback(
    async (userId: string): Promise<IntegrationAccess[] | void> => {
      return await execute(() => integrationAccessService.getByUser(userId));
    },
    [execute],
  );

  const grant = useCallback(
    async (request: GrantAccessRequest): Promise<IntegrationAccess | void> => {
      return await execute(() => integrationAccessService.grant(request), { successMessage: "Acceso otorgado correctamente" });
    },
    [execute],
  );

  const revoke = useCallback(
    async (id: string): Promise<void> => {
      return await execute(() => integrationAccessService.revoke(id), { successMessage: "Acceso revocado correctamente" });
    },
    [execute],
  );

  const update = useCallback(
    async (id: string, enabled: boolean): Promise<void> => {
      return await execute(() => integrationAccessService.update(id, enabled), { successMessage: "Acceso actualizado correctamente" });
    },
    [execute],
  );

  return {
    loading,
    error,
    getAll,
    getByUser,
    grant,
    revoke,
    update,
  };
}
